import Api from '../../../services/api';

// Submenus de "% Indicadores" do DRE que aceitam configuração automática por IA.
export const AI_CONFIG_TARGET = {
  dre: 'dre',
  kpi: 'kpi',
  financialGroups: 'financialGroups',
};

export const dreAiConfigApi = {
  // Só sugere: o backend lê DRE/categorias/contexto da empresa e devolve a proposta validada.
  suggest: (syncId, target) =>
    Api.post(`/sync/${syncId}/dre-indicators/ai-suggest`, { target }, { timeout: 180000 }).then(({ data }) => data),
};
